import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export interface PasswordHasBeenPwnedErrorProps {
    errorMessage?: string;
}

export const PasswordHasBeenPwnedError = ({
    errorMessage,
}: PasswordHasBeenPwnedErrorProps) => {
    const { t } = useTranslation();
    return (
        <Alert data-testid="kratos-password-error" severity="error">
            {errorMessage || t('formErrors.kratosPasswordError.pwned')}
        </Alert>
    );
};
